import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import { MODALS } from "@/constants/modals"
import ProjectsShow from "@/features/pages/Projects/ProjectsShow"
import { useProjectsData } from "@/queries/queries"
import { plusIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"

export default function Projects() {
  const projectQuery = useProjectsData()
  const { editModalState } = useStore()
  const { t } = useTranslation()

  let content
  if (projectQuery.isLoading) {
    content = <Loading />
  } else if (!projectQuery.data?.data.length) {
    content = <NoMessage name={t("noMessages.projects")} />
  } else {
    content = (
      <>
        <ProjectsShow projects={projectQuery.data.data} />

        <Pagination pagination={projectQuery.data.meta} route="projects" />
      </>
    )
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">{t("projectsPage.title")}</h5>

        <div>
          <Button
            onClick={() => editModalState(MODALS.projects.add, true)}
            icon={plusIcon}
          >
            {t("buttons.add")}
          </Button>
        </div>
      </div>
      {content}
    </div>
  )
}
